import { hits } from 'instantsearch.js/es/widgets';
import { strlCurrentDay } from '../../helpers';

export default function Hits(templates, container = '#hits', cssClasses = {}, isEventOverview = false) {
	return hits({
		container,
		templates,
		cssClasses,
		transformItems(items) {
			return items.map((item) => {
				const originalHighlight = item._highlightResult || {};
				const titleHighlight = originalHighlight.title
					? {
							...originalHighlight.title,
							value: originalHighlight.title.value.replace(/&amp;/g, '&'),
						}
					: undefined;

				const newHighlightResult = {
					...originalHighlight,
					...(titleHighlight && { title: titleHighlight }),
				};
				return {
					...item,
					_highlightResult: newHighlightResult,
				};
			});
		},
	});
}
